var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "room-controls-component" }, [
    _c("div", { staticClass: "room-controls" }, [
      _c("div", { staticClass: "room-controls-start" }, [
        _c("div", { staticClass: "room-info" }, [
          _c(
            "div",
            { staticClass: "room-info-title-wrapper" },
            [
              _vm.isRoomMode("group")
                ? _c(
                    "VButton",
                    {
                      staticClass: "room-group-setting-button small group",
                      class: { "pointer-events-none": _vm.isParticipantRole() },
                      attrs: {
                        icon:
                          _vm.isMobile || _vm.isParticipantRole()
                            ? ""
                            : "setting_white",
                      },
                      on: { click: _vm.onToggleGroupSettingModal },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("control.groupDiscussion")) +
                          _vm._s(
                            _vm.me.roomGroupId == undefined ||
                              _vm.me.roomGroupId === "default"
                              ? ""
                              : " (" +
                                  _vm.getRoomGroupName(_vm.me.roomGroupId) +
                                  ")"
                          )
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.isWebinar
                ? _c("div", { staticClass: "room-live-status" }, [
                    _vm._v(
                      _vm._s(
                        _vm.currentWebinarType === "wall"
                          ? "class"
                          : _vm.currentWebinarType
                      )
                    ),
                  ])
                : _vm._e(),
              _vm.useDefinePasswd
                ? _c("GrmIcon", { attrs: { icon: "lock-blue" } })
                : _vm._e(),
              _c("p", { staticClass: "room-info-title" }, [
                _vm._v(_vm._s(_vm.room.roomTitle)),
              ]),
            ],
            1
          ),
          _c("div", { staticClass: "room-info-user-count-wrapper" }, [
            _c(
              "p",
              {
                staticClass: "room-info-user-count",
                on: {
                  click: (e) => {
                    let now = Date.now()
                    if (now - (e.target._last_time || 0) > 2000) {
                      e.target._cnt = 0
                    }
                    e.target._last_time = now
                    e.target._cnt++
                    if (e.target._cnt >= 5) {
                      e.target._cnt = 0
                      _vm.openLogMonitorPage()
                    }
                  },
                },
              },
              [_vm._v(_vm._s(_vm.roomUserCount))]
            ),
          ]),
        ]),
      ]),
      _c(
        "div",
        {
          staticClass: "room-controls-center",
          class: { isOpen: _vm.isShowMobileControls },
        },
        [
          _c("div", { staticClass: "room-control-list-wrapper" }, [
            _c("ul", { staticClass: "room-control-list" }, [
              _c("li", { staticClass: "room-control-item" }, [
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip.bottom",
                        value: _vm.isEnableDevice("speaker")
                          ? _vm.$t("control.device.setting.speaker")
                          : _vm.$t("control.noRole"),
                        expression:
                          "isEnableDevice('speaker') ? $t('control.device.setting.speaker') : $t('control.noRole')",
                        modifiers: { bottom: true },
                      },
                    ],
                    staticClass: "room-control-button speaker",
                    attrs: {
                      "data-device-status": _vm.me.speakerStatus,
                      "data-device-role": _vm.isEnableDevice("speaker"),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onToggleUserDeviceStatus({
                          deviceType: "speaker",
                        })
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "room-control-button-text" }, [
                      _vm._v(_vm._s(_vm.$t("common.device.speaker"))),
                    ]),
                  ]
                ),
              ]),
              _c("li", { staticClass: "room-control-item" }, [
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip.bottom",
                        value: _vm.isEnableDevice("camera")
                          ? _vm.$t("control.device.setting.camera")
                          : _vm.$t("control.noRole"),
                        expression:
                          "isEnableDevice('camera') ? $t('control.device.setting.camera') : $t('control.noRole')",
                        modifiers: { bottom: true },
                      },
                    ],
                    staticClass: "room-control-button cam",
                    attrs: {
                      "data-device-role": _vm.isEnableDevice("camera"),
                      "data-device-status": _vm.me.cameraStatus,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onToggleUserDeviceStatus({
                          deviceType: "camera",
                        })
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "room-control-button-text" }, [
                      _vm._v(_vm._s(_vm.$t("common.device.camera"))),
                    ]),
                  ]
                ),
              ]),
              _c("li", { staticClass: "room-control-item rotate-camera" }, [
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip.bottom",
                        value: "카메라 전환",
                        expression: "'카메라 전환'",
                        modifiers: { bottom: true },
                      },
                    ],
                    staticClass: "room-control-button rotate-camera",
                    on: { click: _vm.onToggleRotateCamera },
                  },
                  [
                    _c("span", { staticClass: "room-control-button-text" }, [
                      _vm._v(_vm._s(_vm.$t("control.device.cameraRotate"))),
                    ]),
                  ]
                ),
              ]),
              _vm.me.micStatus !== "none"
                ? _c("li", { staticClass: "room-control-item" }, [
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip.bottom",
                            value: _vm.micTooltip,
                            expression: "micTooltip",
                            modifiers: { bottom: true },
                          },
                        ],
                        staticClass:
                          "room-control-button mic py-1 flex flex-col items-center",
                        attrs: {
                          "data-device-status": _vm.me.micStatus,
                          "data-device-role": _vm.isEnableDevice("mic"),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onToggleUserDeviceStatus({
                              deviceType: "mic",
                            })
                          },
                        },
                      },
                      [
                        _vm.useStt
                          ? _c(
                              "span",
                              { staticClass: "text-sm text-white leading-3" },
                              [_vm._v("STT")]
                            )
                          : _vm._e(),
                        _c(
                          "span",
                          { staticClass: "room-control-button-text" },
                          [_vm._v(_vm._s(_vm.$t("common.device.mic")))]
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm.useInterpreting
                ? _c("li", { staticClass: "room-control-item" }, [
                    _c(
                      "button",
                      {
                        staticClass: "room-control-button interpreting",
                        on: { click: _vm.onToggleInterpretingModal },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "room-control-button-text" },
                          [_vm._v(_vm._s(_vm.$t("control.translation")))]
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _c("li", { staticClass: "room-control-item" }, [
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip.bottom",
                        value: _vm.$t("common.setting"),
                        expression: "$t('common.setting')",
                        modifiers: { bottom: true },
                      },
                    ],
                    ref: "settingBtn",
                    staticClass: "room-control-button setting",
                    on: {
                      click: function ($event) {
                        return _vm.onToggleSettingMenu()
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "room-control-button-text" }, [
                      _vm._v(_vm._s(_vm.$t("common.setting"))),
                    ]),
                  ]
                ),
              ]),
              _vm.isFullscreenEnabled
                ? _c("li", { staticClass: "room-control-item" }, [
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip.bottom",
                            value: _vm.$t("control.fullScreen"),
                            expression: "$t('control.fullScreen')",
                            modifiers: { bottom: true },
                          },
                        ],
                        staticClass: "room-control-button size",
                        class: _vm.isFullScreen ? "decrease" : "increase",
                        on: { click: _vm.onToggleFullScreen },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "room-control-button-text" },
                          [_vm._v(_vm._s(_vm.$t("control.fullScreen")))]
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]
      ),
      _c("div", { staticClass: "room-controls-end" }, [
        _c("div", { staticClass: "room-sub-controls" }, [
          _c("div", { staticClass: "room-sub-control-list-wrapper" }, [
            _c("ul", { staticClass: "room-sub-control-list" }, [
              _vm.useVoiceRequest
                ? _c("li", { staticClass: "room-sub-control-item" }, [
                    _c(
                      "button",
                      { staticClass: "room-sub-control-button voice-request" },
                      [_c("VoiceRequest")],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm.useTranslation
                ? _c(
                    "li",
                    { staticClass: "room-sub-control-item translation" },
                    [_c("BtnTranslation")],
                    1
                  )
                : _vm._e(),
              _vm.useMeetingNote
                ? _c(
                    "li",
                    { staticClass: "room-sub-control-item meeting-note" },
                    [_c("BtnMeetingNote")],
                    1
                  )
                : _vm._e(),
              _vm.useClientRecord
                ? _c(
                    "li",
                    { staticClass: "room-sub-control-item record" },
                    [_c("BtnRecord")],
                    1
                  )
                : _vm._e(),
              _vm.useInviteRoom
                ? _c("li", { staticClass: "room-sub-control-item invite" }, [
                    _c("button", {
                      staticClass: "room-sub-control-button invite",
                      on: { click: _vm.onToggleInviteModal },
                    }),
                  ])
                : _vm._e(),
              _c("li", { staticClass: "room-sub-control-item" }, [
                _c(
                  "button",
                  {
                    staticClass: "room-sub-control-button mobile-controls",
                    on: { click: _vm.onToggleMobileControls },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.device.name")))]
                ),
              ]),
              _c("li", { staticClass: "room-sub-control-item" }, [
                _c("button", {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip.bottom-end",
                      value: _vm.isOpenExtendMenu
                        ? _vm.$t("control.extendMenu.close.tooltip")
                        : _vm.$t("control.extendMenu.open.tooltip"),
                      expression:
                        "isOpenExtendMenu ? $t('control.extendMenu.close.tooltip') : $t('control.extendMenu.open.tooltip')",
                      modifiers: { "bottom-end": true },
                    },
                  ],
                  staticClass: "room-sub-control-button extend-menu-toggle",
                  class: { close: _vm.isOpenExtendMenu },
                  on: {
                    click: function ($event) {
                      return _vm.$emit(
                        "update:isOpenExtendMenu",
                        !_vm.isOpenExtendMenu
                      )
                    },
                  },
                }),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isShowSettingMenu,
            expression: "isShowSettingMenu",
          },
        ],
        ref: "settingMenu",
        staticClass: "select-setting-box",
        attrs: { tabindex: "-1" },
        on: {
          blur: function ($event) {
            return _vm.blurSettingMenu($event)
          },
        },
      },
      [
        _c(
          "div",
          {
            staticClass: "select-setting-item roomSetting",
            on: { click: _vm.onToggleSettingModal },
          },
          [_vm._v(_vm._s(_vm.$t("control.setting.room")))]
        ),
        _c(
          "div",
          {
            staticClass: "select-setting-item deviceSetting",
            on: { click: _vm.onToggleDeviceSettingModal },
          },
          [_vm._v(_vm._s(_vm.$t("control.setting.device")))]
        ),
        _vm.isMixingCallType
          ? _c(
              "div",
              {
                staticClass: "select-setting-item deviceSetting",
                on: { click: _vm.onToggleQualitySettingModal },
              },
              [_vm._v(_vm._s(_vm.$t("control.setting.video")))]
            )
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }